"use client";

import { Component, type ReactNode } from "react";
import { logger } from "@/app/utilities/logger";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

// GPT injects ad markup directly into a div React also renders, so a fast
// unmount/navigation can race with GPT's own DOM mutation and throw
// "removeChild: node is not a child of this node". That error otherwise
// bubbles to the root error boundary and crashes the whole page for what is
// only an ad slot — contain it here instead.
export default class AdErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    logger.error("Ad slot crashed and was contained by AdErrorBoundary", { errorMessage: error.message });
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
